import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  getByIdPlanSelector,
  PLAN_KEY
} from '@gymaholic/packages'
import { getCurrentPlanSelect } from 'modules/plan/redux/selectors/index.js'

export const getDayPointersByIdPlanSelector = id => (state) => {
  const plan = (
    getByIdPlanSelector(id)(state) ||
    getCurrentPlanSelect(state)
  )

  return getValueReduxUtil(plan, PLAN_KEY.DAYS) || []
}
